import { render, staticRenderFns } from "./QuestionTypeVideo.vue?vue&type=template&id=c3b4f3ce"
import script from "./QuestionTypeVideo.vue?vue&type=script&lang=js"
export * from "./QuestionTypeVideo.vue?vue&type=script&lang=js"
import style0 from "./QuestionTypeVideo.vue?vue&type=style&index=0&id=c3b4f3ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports